import "./SecondSection.scss";
import { Tab, Nav } from "react-bootstrap";
import whiteBuilding from "../../../../../Assets/Images/white-building.webp";
import relaxationCenter from "../../../../../Assets/Images/relaxation-center.webp";
import checked from "../../../../../Assets/Images/icon/tick-circle-blue.png";
import trendsUp from "../../../../../Assets/Images/icon/trend-up.png";
import profile from "../../../../../Assets/Images/icon/profile-2user.png";

export default function SecondSection() {
  return (
    <section id="platforms-section">
      <Tab.Container defaultActiveKey="realestate">
        <div className="tab-buttons">
          <Nav
            variant="pills"
            className="custom-tabs justify-content-center mb-3"
          >
            <Nav.Item>
              <Nav.Link eventKey="realestate">Real Estate</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="ecommerce">Building Materials</Nav.Link>
            </Nav.Item>
          </Nav>
        </div>

        <Tab.Content className="tab-content-area">
          <Tab.Pane eventKey="realestate">
            <div className="pane-flex">
              <div className="eCommerceContentCon">
                <h3>
                  Discover Properties. Secure Financing. Build Your Future.
                </h3>
                <div className="subContentWrapper">
                  <div className="contentOne">
                    <div className="checkedIcon">
                      <img src={checked} alt="checked" />
                    </div>
                    <div>
                      <h6>Wide Range of Verified Properties</h6>
                      <p>
                        Buyers can explore residential and investment
                        opportunities across trusted real estate projects.
                      </p>
                    </div>
                  </div>
                  <div className="contentOne">
                    <div className="checkedIcon">
                      <img src={trendsUp} alt="trendsUp" />
                    </div>
                    <div>
                      <h6>Smart Search & Easy Access</h6>
                      <p>
                        Filter by location, price, or property type to quickly
                        find options that match your budget and needs.
                      </p>
                    </div>
                  </div>
                  <div className="contentOne">
                    <div className="checkedIcon">
                      <img src={profile} alt="profile" />
                    </div>
                    <div>
                      <h6>Flexible Financing Options</h6>
                      <p>
                        Access mortgage solutions that make it possible to own
                        property without paying 100% upfront.
                      </p>
                    </div>
                  </div>
                </div>
                <a href="/estate-home">
                  <button className="btn heroBtn heroBtn-filled d-none d-md-block">
                    Browse Real Estate Projects <span>→</span>
                  </button>
                </a>
              </div>
              <div className="imgCon">
                <img
                  className="p-3 imgCon"
                  src={relaxationCenter}
                  alt="Real estate"
                />
              </div>
              <a href="/estate-home">
                <button className="btn heroBtn heroBtn-filled d-md-none mob-btn">
                  Browse Real Estate Projects <span>→</span>
                </button>
              </a>
            </div>
          </Tab.Pane>

          <Tab.Pane eventKey="ecommerce">
            <div className="pane-flex">
              <div className="eCommerceContentCon">
                <h3>Quality Materials, Delivered On Time, Every Time.</h3>
                <div className="subContentWrapper">
                  <div className="contentOne">
                    <div className="checkedIcon">
                      <img src={checked} alt="checked" />
                    </div>
                    <div>
                      <h6>Direct Access to Products</h6>
                      <p>
                        Buyers can access construction essentials like cement,
                        iron rods, wood, and more, all sourced from verified
                        channels.
                      </p>
                    </div>
                  </div>
                  <div className="contentOne">
                    <div className="checkedIcon">
                      <img src={trendsUp} alt="trendsUp" />
                    </div>
                    <div>
                      <h6>Seamless Ordering & Delivery</h6>
                      <p>
                        Place bulk orders or request quotes easily, and have
                        your materials delivered directly to your site, on time.
                      </p>
                    </div>
                  </div>
                  <div className="contentOne d-none">
                    <div className="checkedIcon">
                      <img src={profile} alt="profile" />
                    </div>
                    <div>
                      <h6>Seamless Ordering & Delivery</h6>
                      <p>
                        Place bulk orders or request quotes easily, and have
                        your materials delivered directly to your site, on time.
                      </p>
                    </div>
                  </div>
                </div>
                <a href="/construction-home" className="d-none d-md-block">
                  <button className="btn heroBtn heroBtn-filled">
                    Browse Building Materials <span>→</span>
                  </button>
                </a>
              </div>
              <div className="imgCon">
                <img
                  className="p-3 imgCon"
                  src={whiteBuilding}
                  alt="E-commerce"
                />
              </div>
              <a href="/construction-home" className="d-md-none mob-btn">
                <button className="btn heroBtn heroBtn-filled">
                  Browse Building Materials <span>→</span>
                </button>
              </a>
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </section>
  );
}